import './status-legend.scss';
import { h } from 'preact';

import Status from './components/Status/Status';

export default function StatusLegend({ statuses, mapId, handleChange }) {
	return (
		<div class="status-legend-container">
			{statuses.length > 0 ?
				<ul class="status-items-container">
					{statuses.map(status => (
						<li class="status-item-container">
							<Status {...status} id={`status-${status.value}-map-${mapId}`} handleChange={handleChange} />
						</li>
					))}
				</ul>
				: ''}
		</div>
	);
}
